import _extends from "@babel/runtime/helpers/extends";
import _defineProperty from "@babel/runtime/helpers/defineProperty";
import _objectWithoutProperties from "@babel/runtime/helpers/objectWithoutProperties";
var _excluded = ["style", "tag", "numberOfLines", "selectable", "testID"];

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) { symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); } keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { _defineProperty(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

import React from 'react';
import { prefixStyle } from '@lada/prefix';
import systemFontsDefaultLetterSpacing from '@bubble-ui/particle-system-fonts-default-letter-spacing';

var Text = function Text(_ref) {
  var style = _ref.style,
      tag = _ref.tag,
      numberOfLines = _ref.numberOfLines,
      selectable = _ref.selectable,
      testID = _ref.testID,
      props = _objectWithoutProperties(_ref, _excluded);

  var mergedStyles = React.useMemo(function () {
    var restOfStyles = style || {};
    var letterSpacing = restOfStyles.letterSpacing ? restOfStyles.letterSpacing : systemFontsDefaultLetterSpacing(restOfStyles.fontSize); // @ts-expect-error

    return prefixStyle(_objectSpread(_objectSpread(_objectSpread({
      // IE 11 + flexbox fix
      maxWidth: '100%'
    }, restOfStyles), restOfStyles.lineHeight && {
      lineHeight: "".concat(restOfStyles.lineHeight, "px")
    }), {}, {
      letterSpacing: "".concat(letterSpacing, "px"),
      fontSmoothing: 'antialiased',
      textRendering: 'geometricPrecision',
      textSizeAdjust: 'none'
    }));
  }, [style]);

  switch (tag) {
    case 'paragraph':
      return /*#__PURE__*/React.createElement("p", _extends({
        style: mergedStyles
      }, props));

    case 'h1':
      return /*#__PURE__*/React.createElement("h1", _extends({
        style: mergedStyles
      }, props));

    case 'h2':
      return /*#__PURE__*/React.createElement("h2", _extends({
        style: mergedStyles
      }, props));

    case 'h3':
      return /*#__PURE__*/React.createElement("h3", _extends({
        style: mergedStyles
      }, props));

    default:
      return /*#__PURE__*/React.createElement("span", _extends({
        style: mergedStyles
      }, props));
  }
};

export default Text;
//# sourceMappingURL=index.js.map